import { Table } from 'antd';
import moment from 'moment';
import { formatFilePath, formatMoney, getRandomColor } from '../../../utils';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const columns = [
	{
		title: 'Date',
		dataIndex: 'lastModifiedDate',
		render: (item) => <span>{moment(item).format('Do MMM YYYY')}</span>,
		sorter: (a, b) => a - b,
	},
	{
		title: 'Member',
		render: (item) => (
			<>
				<div className="w-full flex items-center gap-[.5rem]">
					<img
						src={item?.user?.usrLogo
							? formatFilePath(item?.user?.usrLogo)
							: `https://ui-avatars.com/api/?name=${encodeURIComponent(item?.gpmName)}&background=${getRandomColor()}&color=fff`}
						className="w-[2.1875rem] h-[2.1875rem] rounded-full object-cover"
						alt="avatar"
					/>
					<span>{item?.gpmName}</span>
				</div>
			</>
		),
	},
	{
		title: 'Total balance (KES)',
		dataIndex: 'gpmRunningBalance',
		render: (item) => <span>{formatMoney(item, 'KES')}</span>,
	},
];

export default function MembersTotalBalanceTable() {
	const { members } = useSelector((state) => state.fetch);

	useEffect(() => {}, [members]);

	return (
		<>
			<Table
				rowKey='gpmId'
				className='mt-[1.5rem] !w-full'
				pagination={false}
				columns={columns}
				dataSource={members}
				scroll={{
                    x: 600,
                }}
			/>
		</>
	);
}
